import React, { useCallback, useMemo } from "react";
import { Col, Container, Content, Description, Title } from "../styles";
import { Button } from "../../../shared/components";
import history from "../../../services/history";

const HaveAccount = (props) => {
	const { userAccount } = props;

	/**
	 *
	 * @param {"LOGIN" | "RECOVER_ACCOUNT"} param
	 */
	const goTo = (param) => {
		const routes = {
			LOGIN: () => history.push("/onboard/login"),
			RECOVER_ACCOUNT: () => history.push("/onboard/recover-account"),
		};

		routes[param]();
	};

	return (
		<Container>
			<Content>
				<Title>Você já tem uma conta</Title>
				<Messages props={userAccount} />
				<Col className="w-100 gap-3">
					<Button
						title="Entrar na minha conta"
						btnType="default"
						onClick={() => goTo("LOGIN")}
					/>
					<Button
						title="Esqueci minha senha"
						btnType="outline"
						onClick={() => goTo("RECOVER_ACCOUNT")}
					/>
				</Col>
			</Content>
		</Container>
	);
};

const Messages = ({ props }) => {
	const accounts = useMemo(() => {
		const platforms = {
			TRADEMAP: { platform: "TradeMap", color: "#01E59B" },
			MINHAS_ECONOMIAS: { platform: "Minhas Economias", color: "#00B278" },
			ROCKET_TRADER: { platform: "RocketTrader", color: "#0056FF" },
		};

		return props
			.filter((item) => item.hasAccess)
			.map((item) => ({
				product: platforms[item.cdApplication].platform,
				color: platforms[item.cdApplication].color,
			}))
			.sort((a, b) => b.product.localeCompare(a.product));
	}, []);

	const formatPlatforms = useCallback(
		/**
		 * @param {Array<{product: string, color: string}>} data
		 * @param {string} separatorFinal
		 * @param {boolean} ignoreFistItem
		 */
		(data, separatorFinal, ignoreFistItem = false) => {
			const list = ignoreFistItem ? data.slice(1) : data;

			return list.map((item, index) => {
				const isLast = index === list.length - 1;
				const isSecondToLast = index === list.length - 2;

				let separador = "";

				if (!isLast) {
					separador = isSecondToLast ? ` ${separatorFinal} ` : ", ";
				}

				return (
					<React.Fragment key={index}>
						<span style={{ color: item.color }}>{item.product}</span>
						{separador}
					</React.Fragment>
				);
			});
		},
		[accounts]
	);

	return (
		<Col className="gap-3">
			{accounts.length > 1 ? (
				<>
					<Description>
						O {formatPlatforms(accounts, "e o")} fazem parte do mesmo
						ecossistema de aplicativos.
					</Description>
					<Description>
						Notamos que você já tem conta no{" "}
						{formatPlatforms(accounts, "e no", true)}.
					</Description>
					<Description>
						Entre na sua conta usando as mesmas credenciais de acesso,
						ou crie uma nova senha
					</Description>
				</>
			) : (
				<Description>
					Para entrar, é só usar sua senha e, se precisar, crie uma nova. Vamos
					lá?
				</Description>
			)}
		</Col>
	);
};

export default HaveAccount;
